import EmptyState from '../components/EmptyState.jsx';
import Button from '../components/Button.jsx';

export default function NotFound() {
  return (
    <div style={{ padding: 'calc(env(safe-area-inset-top) + 2rem) 1rem 2rem', maxWidth: 640 }}>
      <EmptyState
        icon="info"
        title="Nothing here"
        action={
          <Button variant="primary" to="/">
            Back to decks
          </Button>
        }
      >
        This page doesn’t exist, or the item was deleted on another device.
      </EmptyState>
    </div>
  );
}
